// https://github.com/abouolia/sticky-sidebar

import 'resize-sensor/ResizeSensor.min';
import 'sticky-sidebar/dist/jquery.sticky-sidebar';

function initTabsSticky() {
    const sections = document.querySelectorAll('.tabs-sticky-wrap');

    sections.forEach(section => {
        const sidebarNav = section.querySelector('.tabs__nav');
        if (!sidebarNav) return;

        if (sidebarNav._sticky) {
            sidebarNav._sticky.destroy();
        }

        sidebarNav._sticky = new StickySidebar(sidebarNav, {
            topSpacing: 235,
            bottomSpacing: 0,
            container: section,
            innerWrapperSelector: '.tabs__nav-wrap'
        });
    });
}

window.addEventListener('load', () => {
    setTimeout(initTabsSticky, 200);
});

window.addEventListener('resize', () => {
    setTimeout(initTabsSticky, 200);
});

window.addEventListener('load', function () {
    initFloatingSectionLabel();

    if (document.querySelector('.services-tabs__fixed-image')) {
        const sidebarEl = document.querySelector('.services-tabs__fixed-image-wrap');
        new StickySidebar(sidebarEl, {
            topSpacing: 145,
            bottomSpacing: 200,
            containerSelector: '.tabs-sticky-wrap',
            innerWrapperSelector: '.services-tabs__fixed-image',
        });
    }

    if (document.querySelector('.js-tab-awards-text-wrap')) {
        const sidebarEl = document.querySelector('.js-tab-awards-text-wrap');
        new StickySidebar(sidebarEl, {
            topSpacing: 145,
            bottomSpacing: 0,
            containerSelector: '.tab-awards__wrap',
            innerWrapperSelector: '',
        });
    }

    const stickyElements = document.querySelectorAll('.core-values-sticky-el');

    if (stickyElements.length > 0) {
        stickyElements.forEach((el) => {
            new StickySidebar(el, {
                topSpacing: 120,
                bottomSpacing: 0,
                containerSelector: '.core-values__in-wrap',
                innerWrapperSelector: '.core-values-sticky-inner'
            });
        });
    }

    if (document.querySelector('.posts-grid__sidebar')) {
        new StickySidebar('.posts-grid__sidebar', {
            topSpacing: 90,
            bottomSpacing: 120,
            containerSelector: '.posts-grid__wrap-inner'
        });
    }
});

function initFloatingSectionLabel() {
    const labelBlocks = Array.from(document.querySelectorAll('.section-label-block')).filter((block) => {
        const textEl = block.querySelector('.section-label-text');
        const section = block.closest('section');

        if (!textEl || !section) return false;

        if (
            section.classList.contains('hero-primary') ||
            section.classList.contains('hero') ||
            section.classList.contains('hero-content-panel') ||
            section.hasAttribute('data-label-ignore')
        ) {
            return false;
        }

        return true;
    });

    if (!labelBlocks.length) return;

    const items = labelBlocks.map((block) => {
        const section = block.closest('section');
        const textEl = block.querySelector('.section-label-text');

        return {
            block,
            section,
            text: textEl.textContent.trim()
        };
    });

    if (!items.length) return;

    document.body.classList.add('has-floating-section-label');

    const floating = document.createElement('div');
    floating.className = 'floating-section-label';
    floating.innerHTML = `
        <div class="floating-section-label__inner">
            <span class="floating-section-label__text"></span>
        </div>
    `;
    document.body.appendChild(floating);

    const textEl = floating.querySelector('.floating-section-label__text');

    let currentIndex = -1;
    let isAnimating = false;
    let rafId = null;
    let resizeRaf = null;
    let animationTimer = null;

    function getTopOffset() {
        const rootStyle = getComputedStyle(document.documentElement);
        return parseFloat(rootStyle.getPropertyValue('--section-label-fixed-top')) || 225;
    }

    function getAnchorBlock() {
        return items[0]?.block || null;
    }

    function getAnchorRect() {
        const anchor = getAnchorBlock();
        if (!anchor) return null;
        return anchor.getBoundingClientRect();
    }

    function getBounds() {
        const first = items[0];
        const last = items[items.length - 1];

        if (!first || !last) return null;

        const rootStyle = getComputedStyle(document.documentElement);
        const fixedTop = parseFloat(rootStyle.getPropertyValue('--section-label-fixed-top')) || 225;
        const initialOffset = parseFloat(rootStyle.getPropertyValue('--section-label-initial-offset')) || 28;
        const bottomOffset = parseFloat(rootStyle.getPropertyValue('--section-label-bottom-offset')) || 12;

        const scrollY = window.pageYOffset || document.documentElement.scrollTop;

        const firstRect = first.section.getBoundingClientRect();
        const lastRect = last.section.getBoundingClientRect();

        const firstTopAbs = scrollY + firstRect.top;
        const lastBottomAbs = scrollY + lastRect.bottom;

        const labelSpan = Math.max(
            textEl.scrollWidth || 0,
            Math.ceil(textEl.getBoundingClientRect().height) || 0,
            80
        );

        const startTopAbs = firstTopAbs + initialOffset;

        const endTopAbs = lastBottomAbs - labelSpan - bottomOffset;

        const startFixScroll = startTopAbs - fixedTop;
        const endFixScroll = endTopAbs - fixedTop;

        return {
            startTopAbs,
            endTopAbs,
            startFixScroll,
            endFixScroll
        };
    }

    function getActiveIndex() {
        const topOffset = getTopOffset();
        const triggerY = topOffset + 20;
        const hysteresis = 40;

        if (currentIndex >= 0 && items[currentIndex]) {
            const currentRect = items[currentIndex].section.getBoundingClientRect();

            if (
                currentRect.top <= triggerY + hysteresis &&
                currentRect.bottom > triggerY - hysteresis
            ) {
                return currentIndex;
            }
        }

        let activeIndex = 0;

        for (let i = 0; i < items.length; i++) {
            const rect = items[i].section.getBoundingClientRect();

            if (rect.top <= triggerY && rect.bottom > triggerY) {
                activeIndex = i;
                break;
            }

            if (rect.top <= triggerY) {
                activeIndex = i;
            }
        }

        return activeIndex;
    }

    function setTextInstant(index) {
        if (!items[index]) return;

        currentIndex = index;
        textEl.textContent = items[index].text;
        textEl.classList.remove('is-out');
        textEl.classList.add('is-initialized', 'is-visible');
    }

    function animateTextChange(index) {
        if (!items[index]) return;
        if (index === currentIndex || isAnimating) return;

        isAnimating = true;

        textEl.classList.remove('is-visible');
        textEl.classList.add('is-out');

        clearTimeout(animationTimer);
        animationTimer = setTimeout(() => {
            textEl.textContent = items[index].text;
            textEl.classList.remove('is-out');
            textEl.classList.add('is-in');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    textEl.classList.remove('is-in');
                    textEl.classList.add('is-visible');
                    currentIndex = index;
                    isAnimating = false;
                });
            });
        }, 180);
    }

    function updatePosition() {
        const anchorRect = getAnchorRect();
        const bounds = getBounds();

        if (!anchorRect || !bounds) return;

        const rootStyle = getComputedStyle(document.documentElement);
        const fixedTop = parseFloat(rootStyle.getPropertyValue('--section-label-fixed-top')) || 225;

        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const left = anchorRect.left + (anchorRect.width / 2);

        floating.style.left = `${left}px`;
        floating.style.width = `${anchorRect.width}px`;

        floating.classList.remove('is-absolute-top', 'is-fixed', 'is-absolute-bottom');

        if (scrollY < bounds.startFixScroll) {
            floating.classList.add('is-absolute-top');
            floating.style.top = `${bounds.startTopAbs}px`;
        } else if (scrollY >= bounds.endFixScroll) {
            floating.classList.add('is-absolute-bottom');
            floating.style.top = `${bounds.endTopAbs}px`;
        } else {
            floating.classList.add('is-fixed');
            floating.style.top = `${fixedTop}px`;
        }
    }

    function update() {
        updatePosition();

        const activeIndex = getActiveIndex();

        if (currentIndex === -1) {
            setTextInstant(activeIndex);
            return;
        }

        animateTextChange(activeIndex);
    }

    function onScroll() {
        if (rafId) return;

        rafId = requestAnimationFrame(() => {
            update();
            rafId = null;
        });
    }

    function onResize() {
        if (resizeRaf) return;

        resizeRaf = requestAnimationFrame(() => {
            updatePosition();

            if (currentIndex === -1) {
                const activeIndex = getActiveIndex();
                setTextInstant(activeIndex);
            }

            resizeRaf = null;
        });
    }

    setTextInstant(0);
    updatePosition();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(() => {
            onResize();
        });

        items.forEach((item) => {
            resizeObserver.observe(item.section);
            resizeObserver.observe(item.block);
        });
    }
}